import { __assign } from "tslib";
import React from "react";
import { useTranslation } from "./translation";
export function withTranslation(WrappedComponent) {
    return React.forwardRef(function (props, ref) {
        var t = useTranslation();
        return React.createElement(WrappedComponent, __assign(__assign({}, props), { ref: ref, t: t }));
    });
}
//# sourceMappingURL=withTranslation.js.map